export const CLOSE = 'modal/CLOSE';
export const OPEN = 'modal/OPEN';

export const close = () => ({
  type: CLOSE
});

export const open = ({ componentName, componentProps = {} }) => ({
  type: OPEN,
  componentName,
  componentProps
});
